import { META_PHASE_MIN_GAP_MINUTES } from "./metaBudgetScheduleWallSnap";

/**
 * MUI clock minutes step when phased budget rows do **not** snap to Meta’s UTC grid (campaign run
 * schedule). 1-minute lists are unreliable in MUI v6 desktop datetime pickers.
 */
export const CAMPAIGN_RUN_PICKER_MINUTES_STEP = 5;

/** Minimum start/end separation for campaign-run pickers (minute-precision wall times). */
export const CAMPAIGN_RUN_PICKER_MIN_GAP_MINUTES = 1;

export type BudgetPhaseDateTimePickerDefaultsParams = {
  /** When true, phased budget Meta snap (15m grid); when false, campaign run schedule. */
  snapPickerToMetaUtcQuarterHour: boolean;
  pickerMinutesStep?: number;
  minStartEndGapMinutes?: number;
};

export type BudgetPhaseDateTimePickerDefaults = {
  pickerMinutesStep: number;
  minStartEndGapMinutes: number;
};

/**
 * MUI `DateTimePicker` clock step and start/end gap for guided budget range pickers.
 * Overrides win; otherwise Meta snap uses the schedule quantum, run schedule uses minute UX defaults.
 */
export function resolveBudgetPhaseDateTimePickerDefaults(
  params: BudgetPhaseDateTimePickerDefaultsParams
): BudgetPhaseDateTimePickerDefaults {
  const snapMeta = params.snapPickerToMetaUtcQuarterHour;
  /** Meta phased rows: clock step matches {@link META_PHASE_MIN_GAP_MINUTES} (15m UTC grid). */
  const metaPickerMinutesStep = META_PHASE_MIN_GAP_MINUTES;
  return {
    pickerMinutesStep:
      params.pickerMinutesStep ??
      (snapMeta ? metaPickerMinutesStep : CAMPAIGN_RUN_PICKER_MINUTES_STEP),
    minStartEndGapMinutes:
      params.minStartEndGapMinutes ??
      (snapMeta ? META_PHASE_MIN_GAP_MINUTES : CAMPAIGN_RUN_PICKER_MIN_GAP_MINUTES),
  };
}
